import { modals } from "@mantine/modals";
import LoginForm from "./LoginForm";

const LOGIN_MODAL_ID = "login";

const openLoginModal = (onLoginSuccess?: () => void) => {
  modals.open({
    modalId: LOGIN_MODAL_ID,
    title: "Hello, camper!",
    withCloseButton: true,
    centered: true,
    zIndex: 310,
    children: <LoginForm onLoginSuccess={onLoginSuccess} />,
    styles: {
      title: {
        flex: 1,
      },
      header: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  });
};

export { LOGIN_MODAL_ID, openLoginModal };
